@if (!isMessage) {
  @if (visible) {
    <div
      class="notification"
      [class]="type"
      [class.is-column]="isColumn"
      [@notificationScaleInAnimation]
    >
      <button class="delete" (click)="dismiss()"></button>
      <ng-content />
    </div>
  }
}

@if (isMessage) {
  @if (visible) {
    <div
      class="message"
      [class]="type"
      [class.is-column]="isColumn"
      [@notificationScaleInAnimation]
    >
      <div class="message-header">
        <ng-content select="[notification-header]" />
        <button class="delete" (click)="dismiss()"></button>
      </div>
      <div class="message-body">
        <ng-content select="[notification-body]" />
      </div>
    </div>
  }
}
